export const RANK_BADGE_VERSION = 'v1';

export const RANK_BADGE_TIER_IDS = [
  'views.bronze',
  'views.silver',
  'views.gold',
  'views.platinum',
  'views.master',
  'views.legend',
  'campaign_money.bronze',
  'campaign_money.silver',
  'campaign_money.gold',
  'campaign_money.black',
  'affiliate.bronze',
  'affiliate.silver',
  'affiliate.gold',
  'affiliate.six_digits',
  'campaigns.bronze',
  'campaigns.silver',
  'campaigns.gold',
  'renders.bronze',
  'renders.silver',
  'renders.gold',
  'renders.diamond',
  'season.emperor',
  'season.elite',
  'season.master',
  'season.veteran',
] as const;

export type RankBadgeTierId = (typeof RANK_BADGE_TIER_IDS)[number];

const RANK_BADGE_TIER_ID_SET = new Set<string>(RANK_BADGE_TIER_IDS);

export function rankBadgeSrc(tierId: string): string | null {
  if (!RANK_BADGE_TIER_ID_SET.has(tierId)) {
    return null;
  }

  return `/images/ranks/${tierId.replace('.', '-')}-${RANK_BADGE_VERSION}.png`;
}
